import { Link } from "react-router-dom";
import { DEFAULT_ROUTE } from "../routes/domains";
import { Button } from "@/components/ui/button";

function NotFound() {
  return (
    <div className="page-container py-12 text-center">
      <div className="mx-auto max-w-xl">
        <h1 className="mb-4 font-display text-5xl font-semibold tracking-tight">
          Not Found
        </h1>
        <p className="mb-6 text-muted-foreground">
          The page you were looking for doesn&apos;t exist.
        </p>
        <Button asChild>
          <Link to={DEFAULT_ROUTE}>Back to the board</Link>
        </Button>
      </div>
    </div>
  );
}

export default NotFound;
